import floatingTaskActions from './actions/floatingTaskActionCreators';
import approvedHourActions from './actions/approvedHourActionCreators';
import notificationActions from './actions/notificationActionCreators';
import roles from "./utils/roles";
import store from "../index";
import projectActions from "./actions/projectActionCreators";

export function handleWebsocketMessage(message) {
  switch(message.type) {
    case 'RELOAD_FLOATING_TASKS':
      if (roles.userHasAnyOfRoles(JSON.parse(localStorage.getItem('user')), ['PMO'])) {
        store.dispatch(floatingTaskActions.pmoLoadAll());
      } else if (roles.userHasAnyOfRoles(JSON.parse(localStorage.getItem('user')), ['PM'])) {
        store.dispatch(floatingTaskActions.pmLoadAll());
      }
      break;
    case 'RELOAD_NOTIFICATIONS':
      store.dispatch(notificationActions.loadPage(30));
      store.dispatch(notificationActions.loadUnreadPageCount());
      break;
    case 'RELOAD_WEEK_APPROVALS':
      store.dispatch(approvedHourActions.countUnapproved());
      if(store.getState().weekApprovalUi.currentWeek == message.week &&
        store.getState().routing.locationBeforeTransitions.pathname == '/approve') {
        store.dispatch(projectActions.loadMyProjectsForWeekApproval(message.week));
        store.dispatch(projectActions.loadOtherProjectsForWeekApproval(message.week));
      }
      break;
    default:
  }
}



/** WEBPACK FOOTER **
 ** ./src/app/websocket.js
 **/